function FavouriteValidatorsPage() { 
    return (
        <div> Favourites </div>
    );
}


export default FavouriteValidatorsPage;